import { unwrap, wrap } from '../object-wrapper';
import { isDevEnv } from './host-manager';

function setCache(slug, context, object, options = null) {
  if (isUpdated(slug, context, object)) {
    return false;
  }

  const key = getKey(slug, context);

  if (object == null) {
    // eslint-disable-next-line no-undef
    localStorage.removeItem(key);
  } else {
    // eslint-disable-next-line no-undef
    localStorage.setItem(key, JSON.stringify(wrap(object, options)));
  }

  return true;
}

function getCache(slug, context) {
  const key = getKey(slug, context);
  // eslint-disable-next-line no-undef
  const string = localStorage?.getItem(key);

  if (string != null) {
    return unwrap(JSON.parse(string));
  }

  return null;
}

function isUpdated(slug, context, object) {
  return JSON.stringify(object) === getCache(slug, context);
}

function getKey(slug, context) {
  return `${isDevEnv ? 'dev_' : ''}${slug == null ? '' : `${slug}_`}${context}`;
}

export { getCache, setCache };
